import { React, useState } from 'react'
import {
	Box,
	Text,
	Avatar,
	Flex,
	IconButton,
	useDisclosure,
} from '@chakra-ui/react'
import { GA_CATEGORY_NAVBAR } from './../../../../../containers/repository/repo.utils'
import { BsSearch } from 'react-icons/bs'
import { TbEdit } from 'react-icons/tb'
import { ParticipantDrawer } from '../../../../globalComponents/participantDrawer'
import { useSharedContext } from '../../../../../context/shared.context'
import { getMessageUniqueId } from '../../../../../utils/common.util'
import { useRemoveParticipant } from '../../../../../hooks/activity.hooks'
import { useInviteParticipant } from './../../../../../hooks/activity.hooks'
import { useLanguageContext } from './../../../../../context/locale.context'

const GroupUser = ({
	groupUsers,
	user,
	setSelectedParticipant,
	selectedParticipant,
	openCloseClick,
	initialLoad,
}) => {
	const { isOpen: isOpenOne, onOpen, onClose: onCloseOne } = useDisclosure()

	const {
		state: { locale },
	} = useLanguageContext()

	const {
		state: { chatSelectedProfile },
	} = useSharedContext()
	const { mutateAsync: removeMutateAsync } = useRemoveParticipant()
	const { mutateAsync: inviteMutateAsync } = useInviteParticipant()

	const onSubmit = async () => {
		const mapUsers = new Map()
		const addedUsers = []
		const removedUsers = []
		let promise1, promise2

		groupUsers.forEach(item => {
			mapUsers.set(item.asset_id, item)
		})

		selectedParticipant.forEach(item => {
			if (mapUsers.has(item.asset_id)) {
				mapUsers.delete(item.asset_id)
			} else {
				addedUsers.push(item)
			}
		})

		removedUsers.push(...mapUsers.values())

		// Adding participants if new participants were added
		if (addedUsers.length > 0) {
			promise1 = inviteMutateAsync({
				activity_id: chatSelectedProfile.activity_id,
				activity_type_category_id: 27,
				activity_type_id: chatSelectedProfile.activity_type_id,
				participants: addedUsers.map(user => {
					return {
						access_role_id: 1,
						account_id: user.account_id,
						asset_category_id: 1,
						asset_first_name: user.asset_first_name,
						asset_id: user.asset_id,
						asset_type_id: user.asset_type_id,
						message_unique_id: getMessageUniqueId(user.asset_id),
						operating_asset_first_name: user.operating_asset_first_name,
						organization_id: user.organization_id,
						workforce_id: user.workforce_id,
						workforce_name: user.workforce_name,
					}
				}),
			})
		}

		// Removing participants if existing participants were removed
		if (removedUsers.length > 0) {
			const removedParticipants = removedUsers.map(user => {
				return {
					...user,
					access_role_id: 0,
					message_unique_id: getMessageUniqueId(user.asset_id),
				}
			})
			promise2 = removeMutateAsync({
				activity_id: chatSelectedProfile.activity_id,
				activity_participant_collection: JSON.stringify(removedParticipants),
			})
		}

		await Promise.all([promise1, promise2])
		initialLoad()
		onCloseOne()
	}

	return (
		<Box>
			<Box display={'flex'} alignItems='center'>
				<Text
					fontSize={'16px'}
					fontWeight={'500'}
					fontStyle={'normal'}
					ml='1rem'
				>
					{groupUsers?.length} Participants
				</Text>
				<IconButton
					color='brand.700'
					icon={<TbEdit />}
					bg='#F2F3F8'
					onClick={() => {
						onOpen()
					}}
					_hover={{
						background: 'transparent',
					}}
				/>
				{/* <IconButton
					w='50px'
					h='50px'
					color='#000000'
					icon={<BsSearch />}
					bg='#F2F3F8'
				/> */}
			</Box>
			{isOpenOne && (
				<ParticipantDrawer
					headerText={locale['Add Participants']}
					isOpen={isOpenOne}
					onClose={onCloseOne}
					selectedParticipant={selectedParticipant}
					setSelectedParticipant={setSelectedParticipant}
					onSubmit={onSubmit}
				/>
			)}
			<Box h='40vh' overflowY={'auto'}>
				{groupUsers?.length &&
					(groupUsers || []).map((item, i) => (
						<Flex
							justifyItems='center'
							alignItems='center'
							minH='70px'
							key={i}
							bg='#FFFFFF'
							opacity={'0.8'}
							mb='2px'
						>
							<Avatar
								name={item.operating_asset_first_name}
								w='48px'
								h='48px'
								color={'#FFFFFF'}
								bg='brand.700'
								fontSize={'24px'}
								ml='1rem'
								fontWeight={'500'}
							/>
							<Box display={'flex'} flexDirection='column' ml='0.5rem'>
								<Text
									fontSize='14px'
									fontWeight={500}
									color={'brand.700'}
									marginLeft='2'
								>
									{item?.operating_asset_first_name}
								</Text>
								<Text
									fontSize='12px'
									color={'#808080'}
									fontWeight='500'
									marginLeft='2'
								>
									{item?.asset_first_name}
								</Text>
								<Text
									fontSize='12px'
									color={'#808080'}
									fontWeight='500'
									marginLeft='2'
								>
									{item?.operating_asset_phone_number}
								</Text>
							</Box>
						</Flex>
					))}
			</Box>
		</Box>
	)
}

export default GroupUser
